import { route as connection } from '../connection';
import { route as auth } from '../auth';
import { route as entry } from '../entry';
import { route as home } from '../home';
import { route as newsletter } from '../newsletter';
import { route as newsletters } from '../newsletters';
import { route as notFound } from '../not-found';
import { route as targets } from '../targets';

export default [
  auth,
  home,
  connection,
  newsletter,
  newsletters,
  targets,
  notFound,
  entry,
];
